import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { basicAlert } from '../../utils';

@Component({
  selector: 'app-importar-sunat',
  templateUrl: './importar-sunat.component.html',
  styleUrls: ['./importar-sunat.component.css']
})
export class ImportarSunatComponent implements OnInit {

  @Input() objImageSunat: any = {}
  @Input() ruc: string = '';

  public params: any = {};
  public codigo: string = '';

  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private interlocutorService: InterlocutorService,
  ) { }

  ngOnInit(): void {
  }

  importar() {

    if (this.ruc == null || this.ruc == "") {
      basicAlert("El RUC debe tener 11 dígitos", 'warning', 'Aceptar');
      return;
    }

    if (this.ruc.length < 11) {
      basicAlert("El RUC debe tener 11 dígitos", 'warning', 'Aceptar');
      return;
    }

    // if (this.codigo == "") {
    //   basicAlert("El código es obligatorio", 'warning', 'Aceptar');
    //   return;
    // }

    this.params.code = this.objImageSunat.code;
    this.params.cookies = this.objImageSunat.cookies;
    this.spinnerService.activarLoading(true);
    this.interlocutorService.sunat_importar_cliente(this.ruc).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.ruc = '';
      this.codigo = '';
      this.modalactiveService.close(response.body);
    }, err => {
      this.spinnerService.activarLoading(false);
      console.log(err);
      if (err.status >= 500) {
        basicAlert("Servicio no disponible", 'warning', 'Aceptar');
      } else {
        basicAlert(err.error, 'warning', 'Aceptar');
      }
    })
  }

  cancelar() {
    this.modalactiveService.dismiss('canceling');
  }

}
